<template>
    <section class="breadcrumbs-custom">      
        <div v-if="!make_payment" class="parallax-container">
            <div class="material-parallax parallax"><img src="/assets/images/breadcrumbs-bg.jpg" alt="breadcrumbs"></div>
            <div class="breadcrumbs-custom-body parallax-content context-dark">
            <div class="container">
                <h2 class="breadcrumbs-custom-title">Checkout</h2>
            </div>
            </div>
        </div>
        <div class="breadcrumbs-custom-footer">
          <div class="container">
          <ul class="breadcrumbs-custom-path">
                <li><router-link to="/">Home</router-link></li>            
                <li><router-link to="/cart">Cart</router-link></li>            
                <li class="active">Checkout</li>
          </ul>
          </div>
        </div>
    </section>

    <!-- Section checkout form-->
    <section v-if="!make_payment" class="section section-sm section-first bg-default text-md-start">
      <div class="container">
        <div class="row row-50 justify-content-center">
          <div class="col-md-12 col-lg-12 mb-2">
            <div v-if="errorMessage" class="alert alert-danger" role="alert">
              {{ errorMessage }}
            </div>
          </div>
          <div class="col-md-10 col-lg-6">
            <h3 class="fw-medium">Pickup Information</h3>
            <form class="rd-form rd-mailform form-checkout">
              <div class="row row-30">
                <div class="col-sm-12">                    
                  <div class="form-wrap">
                    <select v-model="checkoutData.store_id" class="form-input" :class="{ 'has-error': v$.checkoutData.store_id.$error }" id="checkout-store" ref="selectRef" data-constraints="@Required">
                      <option value="">Select Store</option>
                      <option v-for="store in stores" :key="store.id" :value="store.id">
                        {{ store.name }}
                      </option>
                    </select>
                  </div>
                  <p v-if="v$.checkoutData.store_id.$error" class="text-danger mt-1">Please select store</p>                    
                </div>              
                <div class="col-sm-12">
                  <div class="form-wrap">
                    <input 
                      ref="datepickerRef"
                      v-model="checkoutData.pickup_datetime" 
                      class="form-input custom-underline-input"
                      id="checkout-date"
                      type="text"
                      placeholder="Enter Pickup Date & Time"
                      readonly
                    />                  
                  </div>
                  <p v-if="v$.checkoutData.pickup_datetime.$error" class="text-danger mt-1">Please pickup date and time</p>                    
                </div>                  
                <div class="col-sm-12">
                  <div class="form-wrap">
                    <input v-model="checkoutData.order_notes" class="form-input" id="checkout-order_notes" type="text" name="order_notes"/>
                    <label class="form-label" :class="{ focus: checkoutData.order_notes }" for="checkout-order_notes">Order Notes</label>
                  </div>                    
                </div>                  
              </div>                
            </form>
            <h3 class="fw-medium mt-4">Billing Details</h3>
            <form class="rd-form rd-mailform form-checkout">
              <div class="row row-30">
                <div class="col-sm-6">
                  <div class="form-wrap" :class="{ 'has-error': v$.checkoutData.first_name.$error }">
                    <input v-model="checkoutData.first_name" class="form-input" id="checkout-first-name-1" type="text" data-constraints="@Required"/>
                    <label class="form-label" :class="{ focus: checkoutData.first_name }" for="checkout-first-name-1">First Name</label>
                    <span v-if="v$.checkoutData.first_name.$error" class="form-validation">Required</span>
                  </div>
                </div>
                <div class="col-sm-6">
                  <div class="form-wrap" :class="{ 'has-error': v$.checkoutData.last_name.$error }">
                    <input v-model="checkoutData.last_name" class="form-input" id="checkout-last-name-1" type="text" data-constraints="@Required"/>
                    <label class="form-label" :class="{ focus: checkoutData.last_name }" for="checkout-last-name-1">Last Name</label>
                    <span v-if="v$.checkoutData.last_name.$error" class="form-validation">Required</span>
                  </div>
                </div>
                <div class="col-sm-12">
                  <div class="form-wrap" :class="{ 'has-error': v$.checkoutData.mobile_no.$error }">
                    <input v-model="checkoutData.mobile_no" class="form-input" id="checkout-phone-1" type="text"/>
                    <label class="form-label" :class="{ focus: checkoutData.mobile_no }" for="checkout-phone-1">Phone</label>
                    <span v-if="v$.checkoutData.mobile_no.$error" class="form-validation">Must be 10 digits</span>
                  </div>
                </div>                  
                <div class="col-sm-12">
                  <div class="form-wrap" :class="{ 'has-error': v$.checkoutData.email.$error }">
                    <input v-model="checkoutData.email" class="form-input" id="checkout-email-1" type="email" name="email" data-constraints="@Email @Required"/>
                    <label class="form-label" :class="{ focus: checkoutData.email }" for="checkout-email-1">E-Mail</label>
                    <span v-if="v$.checkoutData.email.$error" class="form-validation">{{ emailErrorMsg }}</span>
                  </div>
                </div>
                <div class="col-sm-12">
                  <div class="form-wrap" :class="{ 'has-error': v$.checkoutData.billing_address1.$error }">
                    <input v-model="checkoutData.billing_address1" class="form-input" id="checkout-address1" type="text" data-constraints="@Required"/>
                    <label class="form-label" :class="{ focus: checkoutData.billing_address1 }" for="checkout-address1">Address 1</label>
                    <span v-if="v$.checkoutData.billing_address1.$error" class="form-validation">Required</span>
                  </div>
                </div>
                <div class="col-sm-12">
                  <div class="form-wrap">
                    <input v-model="checkoutData.billing_address2" class="form-input" id="checkout-address2" type="text"/>
                    <label class="form-label" :class="{ focus: checkoutData.billing_address2 }" for="checkout-address2">Address 2</label>
                  </div>
                </div>
                <div class="col-sm-6">
                  <div class="form-wrap" :class="{ 'has-error': v$.checkoutData.billing_city.$error }">
                    <input v-model="checkoutData.billing_city" class="form-input" id="checkout-city" type="text" data-constraints="@Required"/>
                    <label class="form-label" :class="{ focus: checkoutData.billing_city }" for="checkout-city">City</label>
                    <span v-if="v$.checkoutData.billing_city.$error" class="form-validation">Required</span>
                  </div>
                </div>
                <div class="col-sm-6">
                  <div class="form-wrap" :class="{ 'has-error': v$.checkoutData.billing_state.$error }">
                    <input v-model="checkoutData.billing_state" class="form-input" id="checkout-state" type="text" data-constraints="@Required"/>
                    <label class="form-label" :class="{ focus: checkoutData.billing_state }" for="checkout-state">State</label>
                    <span v-if="v$.checkoutData.billing_state.$error" class="form-validation">Required</span>
                  </div>
                </div>
                <div class="col-sm-12">
                  <div class="form-wrap" :class="{ 'has-error': v$.checkoutData.billing_zipcode.$error }">
                    <input v-model="checkoutData.billing_zipcode" class="form-input" id="checkout-zipcode" type="text" data-constraints="@Required"/>
                    <label class="form-label" :class="{ focus: checkoutData.billing_zipcode }" for="checkout-zipcode">Zipcode</label>
                    <span v-if="v$.checkoutData.billing_zipcode.$error" class="form-validation">Required</span>
                  </div>
                </div>
              </div>
              <!-- <label class="checkbox-inline text-transform-capitalize">
                <input name="input-checkbox-1" value="checkbox-1" type="checkbox"/>My Billing Address and Shipping Address are the same
              </label> -->
            </form>
          </div>
          <div class="col-md-10 col-lg-6">
            <h3 class="fw-medium">Cart total</h3>
            <div class="table-custom-responsive">
              <table class="table-custom table-custom-primary table-checkout">
                <tbody>
                  <tr>
                    <td>Cart Subtotal</td>
                    <td>${{ subtotal.toFixed(2) - gst.toFixed(2) }}</td>
                  </tr>
                  <tr v-if="hasChocolatePlaque && totalChocolatePlaquePrice > 0">
                    <td>Chocolate Plaque</td>
                    <td>+ ${{ totalChocolatePlaquePrice.toFixed(2) }}</td>
                  </tr>
                  <tr>
                    <td>GST (10%)</td>
                    <td>+ ${{ gst.toFixed(2) }}</td>
                  </tr>
                  <tr v-if="discount > 0">
                    <td>Discount</td>
                    <td>- ${{ discount.toFixed(2) }}</td>
                  </tr>
                  <tr>
                    <td>Total</td>
                    <td>${{ total.toFixed(2) }}</td>
                  </tr>
                </tbody>
              </table>

              <p v-if="hasChocolatePlaque && totalChocolatePlaquePrice > 0" class="text-danger small">
                *To add a message on your chosen cake, a chocolate plaque is needed for an extra
                <b>${{ totalChocolatePlaquePrice.toFixed(2) }}</b>.
              </p>
            </div>

            <h3 class="fw-medium mt-4">Payment methods</h3>
            <div class="box-radio mt-4">
              <div class="radio-panel">
                <label class="radio-inline" :class="{ active: checkoutData.payment_option === 'paypal' }">
                  <input
                    type="radio"
                    name="paymentMethod"
                    value="paypal"
                    v-model="checkoutData.payment_option"
                  />
                  PayPal
                </label>
                <div class="radio-panel-content" v-if="checkoutData.payment_option === 'paypal'">
                  <p>
                    Pay via PayPal; you can pay with your credit card if you don't have a
                    PayPal account.
                  </p>
                </div>
              </div>

              <div class="radio-panel">
                <label class="radio-inline" :class="{ active: checkoutData.payment_option === 'card' }">
                  <input
                    type="radio"
                    name="paymentMethod"
                    value="card"
                    v-model="checkoutData.payment_option"
                  />
                  Card Payment
                </label>
                <div class="radio-panel-content" v-if="checkoutData.payment_option === 'card'">
                  <p>
                    Please send a check to Store Name, Store Street, Store Town, Store
                    State / County, Store Postcode.
                  </p>
                </div>
              </div>
              <div class="text-center mt-5">                
                <button class="button button-lg button-primary button-zakaria" @click="placeOrder">Place Order</button>
              </div>
            </div>
          </div>            
        </div>
      </div>
    </section> 
    <section v-else class="section section-xxl bg-default">
      <PaymentPage :checkoutData="checkoutData" @update-make-payment="updateMakePayment"/>
    </section>         
    <DiscountDialog />      
</template>
<script setup>
import { onMounted, nextTick, ref, computed, watch } from 'vue';
import jQuery from 'jquery';
import 'jquery-datetimepicker';
import 'jquery-datetimepicker/build/jquery.datetimepicker.min.css';
import { storeToRefs } from 'pinia'
import { useCartStore } from '@/stores/cart'
import useVuelidate from '@vuelidate/core'
import { required, email, minLength, maxLength, numeric } from '@vuelidate/validators'
import { useCheckoutStore } from '@/stores/checkoutStore';
import PaymentPage from '@/components/PaymentPage.vue';
import { format } from 'date-fns'
import { useAuthStore } from '@/stores/authStore';
import { useCommonStore } from '@/stores/commonStore';
import DiscountDialog from '@/components/common/DiscountDialog.vue';
import { useLoaderStore } from '@/stores/loader';

const loader = useLoaderStore()
const commonStore = useCommonStore()
const { stores } = storeToRefs(commonStore)
const authStore = useAuthStore()
const cartStore = useCartStore()
const { cart, subtotal, gst, discount, total, hasChocolatePlaque, totalChocolatePlaquePrice } = storeToRefs(cartStore)

const checkoutStore = useCheckoutStore()
const { checkoutData, errorMessage } = storeToRefs(checkoutStore)
const selectRef = ref(null)
const make_payment = ref(false)
const datepickerRef = ref(null)

const minDate = computed(() => {
  const today = new Date();
  today.setDate(today.getDate() + 1);
  today.setHours(10, 0, 0, 0); // Set to 10am
  checkoutData.value.pickup_datetime = today
  return today;
});

// Time restrictions (10:00 to 20:00)
const minTime = { hours: 10, minutes: 0 };
const maxTime = { hours: 20, minutes: 0 };

// Disable dates dynamically
const disableDates = computed(() => {
  return (date) => {
    const day = date.getDay()
    if (checkoutData.value.store_id === '6' && day === 1) return true // Monday
    // if (checkoutData.value.store_id === '5' && day === 2) return true // Tuesday
    return false
  }
})

const rules = {
  checkoutData: {
    store_id: { required },
    pickup_datetime: { required },    
    first_name: { required },
    last_name: { required },    
    email: { required, email },
     mobile_no: { required, numeric, minLength: minLength(10), maxLength: maxLength(10) },
    billing_address1: { required },
    billing_city: { required },
    billing_state: { required },
    billing_zipcode: { required }
  },
}

const v$ = useVuelidate(rules, { checkoutData })

const emailErrorMsg = computed(() => {
  if (!v$.value.checkoutData.email.$dirty) return 'Required'
  if (!v$.value.checkoutData.email.required) return 'Required'
  if (!v$.value.checkoutData.email.email) return 'Invalid email format'
  return ''
})

watch(checkoutData.value, (val) => {
  if (val.pickup_datetime && typeof val.pickup_datetime !== 'string') {
    checkoutData.value.pickup_datetime = format(val.pickup_datetime, 'yyyy-MM-dd HH:mm')    
  }
})

function updateMakePayment(value) {
  make_payment.value = value
}

function placeOrder(){    
  v$.value.$touch()    
  if (v$.value.$invalid) {
    errorMessage.value = 'Please fix the form errors before submitting.'
    return
  }  
  errorMessage.value = ''  
  make_payment.value = true
  loader.show("Initializing payment...")
}

const getStoreTimeSettings = (storeId) => {
  storeId = String(storeId);
  if (storeId === '2') { // Truganina
    return { minTime: '10:00', maxTime: '21:00', disabledWeekDays: [7] };
  } else if (storeId === '5') { // Cranbourne
    return { minTime: '11:00', maxTime: '20:00', disabledWeekDays: [7] };
  } else if (storeId === '6') { // Epping
    return { minTime: '11:00', maxTime: '20:00', disabledWeekDays: [1] };
  }
  return { minTime: '10:00', maxTime: '20:00', disabledWeekDays: [7] };
};

onMounted(async () => {
   await nextTick() 
   if (!stores.value.length) {
     await commonStore.getStores()
   }
   cartStore.loadCart()       
   if(authStore.user){
     checkoutData.value.first_name = authStore.user.first_name
     checkoutData.value.last_name = authStore.user.last_name
     checkoutData.value.email = authStore.user.email
     checkoutData.value.mobile_no = authStore.user.mobile_no
     checkoutData.value.billing_address1 = authStore.user.address1 || ''
     checkoutData.value.billing_address2 = authStore.user.address2 || ''
     checkoutData.value.billing_city = authStore.user.billing_city || ''
     checkoutData.value.billing_state = authStore.user.billing_state || ''
     checkoutData.value.billing_zipcode = authStore.user.zipcode || ''
   }

   await nextTick()

   const scriptId = 'script-js-script'

   // Check if the script already exists
   const existingScript = document.getElementById(scriptId)

   if (existingScript) {
      // Replace it: remove and re-add
      existingScript.remove()
   }

   // Create and append a fresh script
   const newScript = document.createElement('script')
   newScript.src = '/assets/js/script.js'
   newScript.id = scriptId
   document.body.appendChild(newScript)  
   const script = document.createElement('script');

  nextTick(() => {
    $("input[type='radio']").each(function () {
      if (!$(this).hasClass("radio-custom")) {
        $(this).addClass("radio-custom").after("<span class='radio-custom-dummy'></span>");
      }
    });

    // initialize select2
    window.$(selectRef.value).select2({
        minimumResultsForSearch: Infinity
    })

    // set default value
    window.$(selectRef.value).val(checkoutData.value.store_id).trigger('change.select2')

    // Vue <- Select2 (user changed dropdown)
    window.$(selectRef.value).on('change', (e) => {
      checkoutData.value.store_id = e.target.value
      checkoutData.value.pickup_datetime = null
      
      const settings = getStoreTimeSettings(e.target.value);
      jQuery(datepickerRef.value).datetimepicker('setOptions', {
        disabledWeekDays: settings.disabledWeekDays,
        minTime: settings.minTime,
        maxTime: settings.maxTime
      });
    })

    const initialSettings = getStoreTimeSettings(checkoutData.value.store_id);

    // initialize datetimepicker
    jQuery(datepickerRef.value).datetimepicker({
      format: 'Y-m-d H:i',
      minDate: minDate.value,
      minTime: initialSettings.minTime,
      maxTime: initialSettings.maxTime,
      step: 30,
      disabledWeekDays: initialSettings.disabledWeekDays,
      onChangeDateTime: function(dp, $input) {
        checkoutData.value.pickup_datetime = $input.val();
      }
    });
  });
 
})
</script>